import React from 'react';
import DataService from '../../../../../../../Service';
import {
    fetchFeedbackRequest,
    fetchFeedbackRequestSuccess,
    fetchFeedbackRequestFailer,
    createFeedbackRequest,
    createFeedbackRequestSuccess,
    createFeedbackRequestFailer,
    fetchFeedbackDropDownListRequest,
    fetchFeedbackDropDownListSuccess,
    fetchFeedbackDropDownListFailer,
} from './FeedbackAction';
import { showSnackbar } from "../../../../../../../Components/Snackbar/SnackbarActions";

export const fetchFeedback = (param: any, sessionScenarioId?: number | string, sortByData?: string, employeeId?: string) => {
    return (dispatch: any) => {
        dispatch(fetchFeedbackRequest());
        let params: any = {
            assignment_id: param,
        }

        if (sortByData)
            params.sort_by = sortByData

        if (sessionScenarioId && sessionScenarioId !== 'all')
            params.session_scenario_id = sessionScenarioId || ''

        if (employeeId && employeeId !== 'all')
            params = { ...params, ...(employeeId === "acuity_admin" ? { acuity_admin: true, other_stakeholders: false } : { employee_id: employeeId || "" }), }


        DataService.getData(params, "feedback_listing").then((res: any) => {
            if (res?.success) {
                dispatch(fetchFeedbackRequestSuccess(res?.collate_feedbacks));
            }
        }).catch((error: any) => {
            dispatch(fetchFeedbackRequestFailer(error));
        })
    }
}

export const fetchFeedbackDropdownList = (param: any) => {
    return (dispatch: any) => {
        dispatch(fetchFeedbackDropDownListRequest());
        const params: any = {
            organisation_id: param
        }
        DataService.getData(params, "listing_feedback_dropdown").then((res: any) => {
            if (res?.success) {
                if (res?.success) {
                    dispatch(fetchFeedbackDropDownListSuccess(res));
                }
            }
        }).catch((error: any) => {
            dispatch(fetchFeedbackDropDownListFailer(error));
        })
    }
}


export const createFeedback = (params: any, onClose: () => void, param: any) => {
    return (dispatch: any) => {
        dispatch(createFeedbackRequest());
        DataService.createData(params, "create_feedback").then((res) => {
            if (res?.success) {
                dispatch(createFeedbackRequestSuccess(res));
                onClose();
                dispatch(showSnackbar("success", ["Feedback added successfully!"]));
                dispatch(fetchFeedback(param));
            }
        }).catch((error) => {
            dispatch(createFeedbackRequestFailer(error));
        })
    }
}

export const updateFeedback = (params: any, onClose: () => void,) => {
    return (dispatch: any) => {
        dispatch(createFeedbackRequest());
        DataService.updateData(params, null, "updateFeedback").then((res) => {
            if (res?.success) {
                onClose();
                dispatch(showSnackbar("success", ["Feedback updated successfully!"]));
            }
        }).catch((error) => {
            dispatch(createFeedbackRequestFailer(error));
        })
    }
}

export const deleteFeedback = (feedback_id: any, callback: any) => {
    return (dispatch: any) => {
        DataService.deleteDirectFeild("feedbacks/destroy_feedback", { feedback_id }).then((res) => {
            if (res?.success) {
                callback()
                dispatch(showSnackbar("success", ["Feedback deleted successfully!"]));
            }
        }).catch((error) => {
            dispatch(showSnackbar("error", [error.errors?.length ? error.errors[0] : '']));
        })
    }
}